export default __webpack_public_path__ + "static/media/bear_4.04b308d6.png";